import styled, { css } from 'styled-components';
import { AvatarStyled, Box, Heading } from '@bechtel/gds';

export const BlockHeadingStyled = styled(Heading)`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[400]};
    background: ${theme.colors.grey[200]};
    padding-bottom: ${theme.spacings[500]};
    padding-left: ${theme.spacings[500]};
    padding-right: ${theme.spacings[500]};
    padding-top: ${theme.spacings[600]};
    border: solid 1px ${theme.colors.grey[300]};
    color: ${theme.colors.grey[1000]};
    font-weight: ${theme.fontWeights[600]};
  `}
`;

export const SideSheetSubHeaderStyled = styled(Box).attrs({
  pb: { sm: '100' },
  px: { sm: '500' },
  pt: { sm: '300' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey[300]};
    background-color: ${theme.colors.blue[100]};
  `}
`;
export const CrewIconStyled = styled(AvatarStyled)`
  justify-content: center;
  ${({ theme }) => css`
    padding: ${theme.spacings[300]};
    background-color: ${theme.colors.grey[100]};
    border: 1px solid ${theme.colors.grey[100]};
  `};
`;
